import * as React from 'react';
import PropTypes from 'prop-types';
import colors from '@strava/ui/colors';
import HeartIconUnfilled from './HeartIconUnfilled';
import HeartIconFilled from './HeartIconFilled';

const CommentReactionIcon = ({ canCommentReactStatus }) => {
  const color = canCommentReactStatus
    ? colors.N70_GRAVEL
    : colors.O50_STRAVA_ORANGE;

  return canCommentReactStatus ? (
    <HeartIconUnfilled color={color} size={16} />
  ) : (
    <HeartIconFilled color={color} size={16} />
  );
};

CommentReactionIcon.propTypes = {
  canCommentReactStatus: PropTypes.bool.isRequired
};

export default CommentReactionIcon;
